'use client';

import { Produto as ProdutoType } from '@/types/produto';
import { CSSProperties } from 'styled-components';
import useBreakpoint from '@/hooks/useBreakpoint';
import ProdutoHomeMobile from './Designs/Mobile';
import ProdutoHomeDesktop from './Designs/Desktop';

export type ProdutoHomeProps = ProdutoType & { style?: CSSProperties };

export default function ProdutoHome(props: ProdutoHomeProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <ProdutoHomeMobile {...props} />
  ) : (
    <ProdutoHomeDesktop {...props} />
  );
}
